/** @format */
import { css } from 'styled-components';

const baseStyles = () => {
    return css`
        display: flex;
        max-width: 29rem;
    `;
};

export const styles = () => css`
    ${baseStyles()}
`;
